import { defineEnum } from './enum-base'

export const EventStatus = {
  beforeSale: 'before_sale',
  onSale: 'on_sale',
  endSale: 'end_sale'
}

export const Gender = defineEnum({
  Man: {
    value: '男',
    text: '男'
  },
  Woman: {
    value: '女',
    text: '女'
  }
})

export const Job = [
  '会社員',
  '専門職（教師、弁護士など）',
  '経営者',
  '商工業',
  '農林漁業',
  '自由業',
  'パート、アルバイト',
  '中学生以下',
  '高校生、高専生',
  '専門学校生',
  '短大生',
  '大学生、大学院生',
  '専業主婦（主夫）',
  'その他',
  '無職'
].map((item) => ({
  text: item,
  value: item
}))

export const Prefecture = [
  '海外',
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県'
].map((item) => ({
  text: item,
  value: item
}))

const currentYear = new Date().getFullYear()
export const Year = Array(120)
  .fill(0)
  .map((_, index) => ({
    text: currentYear - index,
    value: currentYear - index
  }))

export const Month = Array(12)
  .fill(0)
  .map((_, index) => ({
    text: index + 1,
    value: index + 1
  }))

export const Day = Array(31)
  .fill(0)
  .map((_, index) => ({
    text: index + 1,
    value: index + 1
  }))
